import { Modal, Form, Row, Col, Select, Button } from "antd";
import { useModalExportacion } from "../../../hooks/useModalExportacion";
import DateInput from "../../../utils/DateInput";

interface IModalExportacion {
  openModal: boolean;
  setOpenModal: Function;
  opcionesSelect: Array<opcionesSelect>;
  modulo: string;
  consulta: string;
}

interface opcionesSelect {
  id: number;
  nombre: string;
  value: string;
}

export const ModalExportacion = ({
  openModal,
  setOpenModal,
  opcionesSelect,
  modulo,
  consulta,
}: IModalExportacion): any => {
  const {
    fechasExportacion,
    setFechasExportacion,
    exportarDatos,
    estadoDatos,
    setEstadoDatos,
  } = useModalExportacion();
  const fields = [
    { name: "fechaHasta", value: fechasExportacion.fechaHasta },
    { name: "fechaDesde", value: fechasExportacion.fechaDesde },
    { name: "estadoDatos", value: estadoDatos },
  ];

  // @ts-ignore
  return (
    <Modal
      maskStyle={{
        backgroundColor: "rgba(31,174,239,0.8)",
        borderRadius: "6px",
      }}
      title="Exportar datos"
      visible={openModal}
      onCancel={() => setOpenModal(!openModal)}
      width={window.innerWidth * 0.5}
      footer={
        <Row justify="end" gutter={[24, 24]}>
          <Col>
            <Button
              className="button-gray-ghost"
              onClick={() => setOpenModal(!openModal)}
            >
              Cancelar
            </Button>
          </Col>
          <Col className="justify-content-flex-end">
            <Button
              className="button-azul-radius"
              htmlType="submit"
              form="modalExportarDatos"
            >
              Exportar datos
            </Button>
          </Col>
        </Row>
      }
    >
      <Form
        fields={fields}
        name="modalExportarDatos"
        onFinish={() => exportarDatos(modulo, consulta)}
      >
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Form.Item
              className="no-margin"
              name="estadoDatos"
              rules={[{ required: true, message: "" }]}
            >
              <Select
                placeholder="Seleccionar..."
                style={{ width: "100%" }}
                onChange={(e) => setEstadoDatos(e)}
                value={estadoDatos}
              >
                {opcionesSelect.map(({ id, nombre, value }) => (
                  <Select.Option key={id} value={value}>
                    {nombre}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Desde
            </span>
            <Form.Item
              className="no-margin"
              // label="Fecha apertura"
              name="fechaDesde"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <DateInput
                save={(fecha) => {
                  setFechasExportacion({
                    ...fechasExportacion,
                    fechaDesde: fecha,
                  });
                }}
                dia={""}
                mes={""}
                anio={""}
              />
            </Form.Item>
          </Col>
          <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Hasta
            </span>
            <Form.Item
              className="no-margin"
              // label="Fecha apertura"
              name="fechaHasta"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <DateInput
                save={(fecha) => {
                  setFechasExportacion({
                    ...fechasExportacion,
                    fechaHasta: fecha,
                  });
                }}
                dia={fechasExportacion.fechaHasta?.split("-")[2] || ""}
                mes={fechasExportacion.fechaHasta?.split("-")[1] || ""}
                anio={fechasExportacion.fechaHasta?.split("-")[0] || ""}
              />
              
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
